import axios from "axios";

let dguMemberDB = axios.create({
  headers: {'x-api-key': localStorage.getItem('x-api-key')}
});

export default {
  namespaced: true,
  state: {
    selectedAuthor: null,
    selectedInstitute: null,
    membernumber: null,
    validmember: null
  },
  actions: {
    GET_AUTHORS: function ({commit, state}, search) {
      return dguMemberDB.post(process.env.VUE_APP_DGU_URL + '/member/search', search)
    },
    GET_AUTHOR: function ({commit, state}, search) {
      return dguMemberDB.get(process.env.VUE_APP_DGU_URL + '/member/get/' + search)
    },
    VALID_MEMBER: function ({commit, state}, id) {
      return dguMemberDB.get(process.env.VUE_APP_DGU_URL + '/member/valid/' + id)
    },
  },
  mutations: {
    SET_SELECTEDAUTHOR: (state, {selectedAuthor}) => {
      state.selectedAuthor = selectedAuthor
    },
    SET_SELECTEDINSTITUTE: (state, {selectedInstitute}) => {
      state.selectedInstitute = selectedInstitute
    },
    SET_VALID_MEMBER: (state, {validMember}) => {
      state.validmember = validMember;
    },
    SET_MEMBER_NUMBER: (state, {membernumber}) => {
      state.membernumber = membernumber;
    }
  },
  getters: {}
}
